export const mainFontFamily = 'Raleway';

export const blackColor = '#000';
export const brightBlackColor = '#24282a';
export const greyColor = '#313131';
export const redColor = '#cf2c47';
export const darkIntenseRedColor = '#e74c3c';
export const ghostWhiteColor = '#f9fbfc';
export const whiteColor = '#fff';

export const buttonStyle = {
  backgroundColor: redColor,
  color: whiteColor,
  textAlign: 'center',
};

export const tableButtonStyle = {
  ...buttonStyle,
  fontSize: '11px',
  borderRadius: '3px',
  padding: '5px 15px 2px',
  fontWeight: '600',
  width: 'fit-content',
  margin: 'auto',
};

export const tableHeaderStyle = {
  paddingLeft: 20,
  paddingRight: 25,
  border: 'none',
};

export const tableBodyStyle = {
  paddingLeft: 20,
  border: 'none',
};
